import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  getFinalRun,
  redirectToVariance,
  setNewRun,
} from '../../store/actions'
import DashedLink from '../DashedLink'
import ButtonSecondary from '../ui/ButtonSecondary'
import './index.css'

const FinalRunJobPage = (props) => {
  const history = useHistory()

  const statusOfLastOrder = props.lastOrder.status

  const typeOfLastOrder = props.lastOrder.type

  const handleClickNewRun = async () => {
    await props.onClickRedirectToVariance()
  }
  const onClickViewProgress = (e) => {
    e.preventDefault()
    history.push(`/jobs/${props.job.UUID}/variance`)
  }


  const handleClickFinalRun = async () => {
    await props.onClickRedirectToVariance()
    props.getFinalRun(true)
  }

  return (
    <div className="variance--final">
      <div className="variance__body">
        {statusOfLastOrder === 'completed' && typeOfLastOrder === 'final_run' ?
          <DashedLink onClick={onClickViewProgress} name={'View Variance'} /> : <>
            <ButtonSecondary
              onClick={() => handleClickNewRun()}
              name="Start New Run"
              className="variance__button"
            />
            <ButtonSecondary
              onClick={() => handleClickFinalRun()}
              name="Start Final Run"
              className="variance__button"
            />
          </>}

      </div>
    </div>
  )
}
const mapStateToProps = ({ data: { newRun, redirect, finalRun } }) => ({
  newRun,
  redirect,
  finalRun,
})

const mapDispatchToProps = {
  setNewRun,
  redirectToVariance,
  getFinalRun,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FinalRunJobPage)

